import PropTypes from 'prop-types';
import React from 'react';

class Link extends React.Component {
  handleClick = e => {
    e.preventDefault();
    const target = e.currentTarget.getAttribute('href');
    if (!target) return null;
    this.context.router.setRoute(target);
  };

  render() {
    return (
      <a onClick={this.handleClick} role="link" tabIndex="0" {...this.props} />
    );
  }
}

Link.contextTypes = {
  router: PropTypes.object,
};

export default Link;
